import { Observable } from 'rxjs';

import { EdgeworthSubstrateDeltaSyncFile } from './edgeworth-data.model';

export abstract class EdgeworthLocalFilesService {
    public abstract getLocalMru(): Observable<ReadonlyArray<EdgeworthSubstrateDeltaSyncFile>>;
}
